import React from "react";
import { Box } from "@mui/material";
import LGModalCrud from "../LGCrud/LGModalCrud";
import SpecificationItemForm from "./SpecificationItemForm";
import {
  getSpecificationItemList,
  deleteSpecificationItem,
} from "../../api/finishedGoods";

export default function CrudSpecificationItems({ props }) {
  const { id, onSubmit } = props;
  const finishedGoodId = id;

  const columns = [
    {
      field: "name",
      headerName: "Nombre",
      flex: 0.3,
    },
    {
      field: "quantity",
      headerName: "Cantidad",
      flex: 0.15,
      type: "number",
    },
    {
      field: "productCategoryName",
      headerName: "Categoría",
      flex: 0.25,
    },
    {
      field: "description",
      headerName: "Descripción",
      flex: 0.3,
    },
  ];

  // Custom fetch function that filters by finishedGoodId
  const fetchSpecificationItems = async (queryParams) => {
    const params = {
      ...queryParams,
      finishedGoodId: finishedGoodId,
    };
    return await getSpecificationItemList(params);
  };

  return (
    <Box width={"100%"}>
      <LGModalCrud
        props={{
          fetchFunction: fetchSpecificationItems,
          deleteFunction: deleteSpecificationItem,
          data: { finishedGoodId },
          columns: columns,
          addModalData: {
            header: "Agregar Especificación",
            body: <SpecificationItemForm finishedGoodId={finishedGoodId} />,
          },
          editModalData: {
            header: "Editar Especificación",
            body: <SpecificationItemForm />,
          },
          actions: ["create", "update", "delete"],
        }}
      />
    </Box>
  );
}